export enum CompanyProductUserMemberRoleEnum {
  PRODUCT_MANAGER = 'product-manager',
  TECH_LEAD = 'tech-lead',
  PRODUCT_DESIGNER = 'product-designer',
  DEVELOPER = 'developer',
}
